import React, { FC } from 'react';

export const AlertIconFilled: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7071 3.00024L21 8.29314V15.7074L15.7071 21.0002H8.29289L3 15.7074V8.29314L8.29289 3.00024H15.7071ZM12 15.0002C11.4477 15.0002 11 15.448 11 16.0002C11 16.5525 11.4477 17.0002 12 17.0002C12.5523 17.0002 13 16.5525 13 16.0002C13 15.448 12.5523 15.0002 12 15.0002ZM12 7.00024C11.4872 7.00024 11.0645 7.38628 11.0067 7.88362L11 8.00024V12.0002C11 12.5525 11.4477 13.0002 12 13.0002C12.5128 13.0002 12.9355 12.6142 12.9933 12.1169L13 12.0002V8.00024C13 7.44796 12.5523 7.00024 12 7.00024Z"
      fill="currentColor"
    />
  </svg>
);
